import { render } from "./itemUrx.vue?vue&type=template&id=e7003346&scoped=true"
import script from "./itemUrx.vue?vue&type=script&lang=js"
export * from "./itemUrx.vue?vue&type=script&lang=js"

import "./itemUrx.vue?vue&type=style&index=0&id=e7003346&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7003346"]])

export default __exports__